
import { useState, useEffect, useRef } from "react";
import { useLocation } from 'react-router-dom';

import { useQuery } from "@tanstack/react-query";

import { IconButton, Button } from "@mui/material";
import TuneIcon from '@mui/icons-material/Tune';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisVertical, faFileExcel} from '@fortawesome/free-solid-svg-icons';

import { Dropdown, Menu, Form, Space, DatePicker, Row, Col } from 'antd';


// import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';

import authAxios from "../components/authAxios";

import moment from 'moment';



// import Layout from "../components/Layout";
import DashboardHeader from "../components/DashboardHeader";
import './EndMonthReport.css'

import { width } from "@fortawesome/free-brands-svg-icons/fa42Group";

import Loading from "../components/Loading";


const CommissionSchedule = () => {
    const location = useLocation();
    const [reportMonth, setReportMonth] = useState(moment().format('MM'))
    const [reportYear, setReportYear] = useState(moment().format('YYYY'))

    const { data: commissionSchedule, isLoading } = useQuery({
        queryKey: ['commission-schedule', reportMonth, reportYear],
        queryFn: async () => {
            const response = await authAxios.get(`/accounting/commission-schedule/?year=${reportYear}`);
            return response.data
        },
    });


    if (isLoading) return <Loading loading={true} />;
    const { headers = [], rows = [], totals } = commissionSchedule;

    console.log("headers",headers)

    const downloadXLS = () => {

        // const worksheetData = rows.map(data => ({
        //     'PROPERTY': data.property,
        //     'JAN': data['Jan'],
        //     'FEB': data['Feb'],
        //     'MAR': data['Mar'],
        //     'APR': data['Apr'],
        //     'MAY': data['May'],
        //     'JUN': data['Jun'],
        //     'JUL': data['Jul'],
        //     'AUG': data['Aug'],
        //     'SEP': data['Sep'],
        //     'OCT': data['Oct'],
        //     'NOV': data['Nov'],
        //     'DEC': data['Dec'],
        //     'TOTAL': data['Total'],
        // })); 

        const worksheetData = rows.map(row => {
            const excelRow = {};
            headers.forEach(header => {
                excelRow[header.toUpperCase()] = row[header];
            });
            return excelRow;
        });

        const totalsRow = {};
        headers.forEach(header => {
            if (header.toLowerCase() === 'property') {
                totalsRow[header.toUpperCase()] = 'TOTALS';
            } else {
                // Get the total for this header from the totals object
                totalsRow[header.toUpperCase()] = parseFloat(commissionSchedule.totals[header] || 0);
            }
        });
    

        // Push the totals row to the worksheet data
        worksheetData.push(totalsRow);

        // Convert data to worksheet
        const ws = XLSX.utils.json_to_sheet(worksheetData);

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Commission Schedule '+reportYear);

        XLSX.writeFile(wb, `Commission_Schedule_${reportYear}.xlsx`);
    };

    const onChange = (date, dateString) => {
        // console.log(date);
        // setReportMonth(date.month()+1)
        setReportYear(date.year())
      };

    const menu = (
        <Menu>
            <form className="filter-form">
                <Space direction="vertical">
                    <DatePicker onChange={onChange} picker="year" placement="bottomRight" />
                </Space>
            </form>
        </Menu>
      );
    // const reportPreTitle="PERIOD "+reportMonth+"/"+reportYear
    const reportPreTitle="PERIOD "+reportYear



    // a helper function to check if a column has data
    const hasColumnData = (columnName) => {
        return commissionSchedule.report_data.some(row => row[columnName] !== 0 && row[columnName] !== null && row[columnName] !== undefined);
      };

    const formatNumber = (number) => {
        return number.toLocaleString('en-UK', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      }


    return (
        <div className="dashboard-main end-month-report expense-schedule">
            <section className="dashboard-content">
                <div className="dashboard-content-header-nav">
                    <DashboardHeader dashboardTitle="Commission Schedule" dashboardPreTitle={reportPreTitle} />
                    <div className="dashboard-content-header-nav-icons">
                        <IconButton onClick={downloadXLS}>
                            <FontAwesomeIcon className="menu-icon" icon={faFileExcel} />
                        </IconButton>
                        <Dropdown overlay={menu} trigger={['click']} placement="bottomRight" arrow>
                      
                        <Button className="menu-button-filter" variant="outlined" startIcon={<TuneIcon />}>
                            Filter
                        </Button>

                    </Dropdown>
                    </div>
                
                </div>
                <div className="table-container">


                <table >
                        <thead>
                            <tr>
                                <th>NO</th>
                                {headers.map(data => (
                                    <th key={data}>{data.toUpperCase()}</th>
                                ))}
                            </tr>
                        </thead>
                          
                        <tbody >
                            {rows.map((data, index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                {headers.map(hdr => (
                                    <td key={hdr}>{data[hdr].toLocaleString()}</td>
                                ))}
                            </tr>
                            ))}

                        </tbody>
                        {totals && (
                            <tfoot>
                                <tr>
                                    <td></td>
                                    {headers.map(hdr => (
                                        <td key={hdr}>
                                            {hdr === "property"
                                                ? "TOTALS"
                                                : totals[hdr].toLocaleString()
                                            }
                                        </td>
                                    ))}
                                </tr>
                            </tfoot>
                        )}


                </table>

                </div>



            </section>
        </div>
    );
};

export default CommissionSchedule;


